import { observer } from 'mobx-react';
import { useUserStore } from '@roc/feature-app-core';
import { BorrowerTrackRecordVerification } from '@roc/feature-track-record-v2';
import { useBorrowerBaseballCardStore } from 'libs/feature-borrowers/src/borrowers/hooks/useBorrowerBaseballCardStore';
import { useBorrowerTrackRecordStore } from "@roc/feature-borrowers";

interface Props {
  borrowerId: number | string;
  loanId: number | undefined;
}

const noop = () => {};

const BorrowerTrackRecord = observer(({ borrowerId, loanId }: Props) => {
  const { borrowerBaseballCardStore } = useBorrowerBaseballCardStore();
  const { borrowerTrackRecordStore } = useBorrowerTrackRecordStore();
  const { userStore } = useUserStore();

  if (!borrowerId) {
    return null
  }

  borrowerBaseballCardStore.currentBorrower = borrowerId;
  borrowerBaseballCardStore.loanId = Number(loanId);

  const onSaveCompleted = () =>
    borrowerBaseballCardStore.fetchBaseballCardData(Number(borrowerId), loanId);

  return (
    // isInternal drives the verify/unverify/remove actions on properties, entities and
    // licenses — external users get the v2 UI read-only.
    <BorrowerTrackRecordVerification
      token=""
      isInternal={userStore.isNportalUser}
      isTpoFlow={false}
      showBanner={false}
      store={borrowerTrackRecordStore}
      borrowerId={Number(borrowerId)}
      onClose={noop}
      onSaveCompleted={onSaveCompleted}
    />
  );
})

export default BorrowerTrackRecord;
